import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';
import { useFpId } from '../hooks/useFpId';

interface Buckets {
  bucketName: string;
  total: number;
}

interface PLDGoalSummaryDTO {
  buckets: Buckets[];
  headline: string;
  isEmpty: boolean;
}

interface FetchGoalsParams {
  clientId: number;
  fpId: string;
}

const fetchPLDGoalSummary = async ({
  clientId,
  fpId,
}: FetchGoalsParams): Promise<PLDGoalSummaryDTO | null> => {
  const { assetBucketingGoal } = await authFetch(
    urlWithParams('/Consumer/AssetBucketingResults/Goal', { clientId, fpId }),
  );

  return assetBucketingGoal;
};

export const usePLDCardQuery = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  return useQuery(
    queryKeys.PLDGoalSummary(clientId, fpId),
    () => fetchPLDGoalSummary({ clientId, fpId }),
    {
      cacheTime: 0,
      enabled: !!fpId,
    },
  );
};
